import _ from 'lodash';

export default new class State {
    state = {};

    get(key, def = null) {
        return _.get(this.state, this._key(key), def);
    }

    put(key, val) {
        _.set(this.state, this._key(key), val);
    }

    putIfNotExists(key, val) {
        if (this.get(this._key(key)) === undefined) {
            return;
        }
        
        _.set(this.state, this._key(key), val);
    }

    remove(key) {
        _.remove(this.state, this._key(key));
    }

    flush() {
        console.log('state flush')
        this.state = null;
        this.state = {};
    }

    _key(key) {
        return Array.isArray(key) ? key.join('-') : key;
    }
}()
